var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm pt-0",
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("당신의 브랜드를 위한 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("맞춤 건강식품 생산")])];
      },
      proxy: true
    }, {
      key: "txt",
      fn: function () {
        return [_vm._v("20년 기술력으로 귀사의 제품을 만들어드립니다")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--lg producing-steps",
    attrs: {
      "justify": "space-between"
    }
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "3",
        "xl": "auto"
      }
    }, [_c('v-card', {
      staticClass: "mx-auto",
      attrs: {
        "img": "/images/main/producing/producing.png",
        "flat": "",
        "width": "240"
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 280 / 320
      }
    }, [_c('v-responsive', {
      staticClass: "d-flex align-center",
      attrs: {
        "aspect-ratio": "1"
      }
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "tit tit--xs primary--text line-height-1"
    }, [_vm._v("STEP 0" + _vm._s(index + 1))]), _c('div', {
      staticClass: "txt grey--text text--darken-4 font-weight-medium mt-8px"
    }, [_vm._v(" " + _vm._s(step.name) + " ")]), _c('v-img', {
      staticClass: "mx-auto mt-8px",
      attrs: {
        "max-width": "60",
        "src": step.icon,
        "alt": ""
      }
    })], 1)])], 1)], 1)], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }